var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 334.635,
    height: 331.563,
    className: "droog-button",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2f55",
    d: "M65.85 285.335A156.812 156.812 0 1 1 269.085 48.069 156.811 156.811 0 1 1 65.85 285.335Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-.15 -.92)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.612 -49.741)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.828,
    cy: 156.793,
    fill: "#0d2f55",
    rx: 156.828,
    ry: 156.793,
    transform: "translate(47.741 68.639)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.828,
    cy: 156.793,
    fill: "#174374",
    rx: 156.828,
    ry: 156.793,
    transform: "translate(26.762 50.661)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18.00252,
    d: "M339.339 373.631 44.007 5.646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 17.99172,
    d: "m3.523 270.782 382.128-159.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18.00234,
    d: "m86.771 451.752 32.837-228.938"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroog);
export default __webpack_public_path__ + "static/media/droog.7c33af4cb338606ada01adeee094629b.svg";
export { ForwardRef as ReactComponent };